import { useState } from "react";
import styles from "./GroupsView.module.scss";
import { View, ViewHeader } from "@/components";
import { GroupsToolbar } from "../groups-toolbar";
import { GroupsList } from "../groups-list";
import { GroupFormDrawer } from "../group-form-drawer";
import { useGroupsQuery } from "../../_hooks/useGroupsQuery";
import type {
  GroupKindFilter,
  GroupPeriodFilter,
  GroupToolbarTab,
} from "../../_constants/groups.const";

export const GroupsView = () => {
  const [tab, setTab] = useState<GroupToolbarTab>("all");
  const [kind, setKind] = useState<GroupKindFilter>("all");
  const [period, setPeriod] = useState<GroupPeriodFilter>("all");
  const [createOpen, setCreateOpen] = useState(false);
  const [editGroupId, setEditGroupId] = useState<string | null>(null);

  const { data, isLoading, isFetching, isError, refetch } = useGroupsQuery({
    kind,
    tab,
  });

  const groups = data ?? [];
  const formOpen = createOpen || Boolean(editGroupId);
  const formMode = editGroupId ? "edit" : "create";

  const closeForm = () => {
    setCreateOpen(false);
    setEditGroupId(null);
  };

  return (
    <View>
      <div className={styles["comp__content"]}>
        <ViewHeader
          heading="Groups"
          description="Organize accounts into licensed groups with seat pools.<br />Membership occupies a seat until explicitly detached (including inactive accounts)."
        />

        <GroupsToolbar
          tab={tab}
          kind={kind}
          period={period}
          onTabChange={setTab}
          onKindChange={setKind}
          onPeriodChange={setPeriod}
          onCreateGroupClick={() => {
            setEditGroupId(null);
            setCreateOpen(true);
          }}
        />

        <GroupsList
          groups={groups}
          isLoading={isLoading}
          isFetching={isFetching}
          isError={isError}
          onRetry={() => void refetch()}
          onSelect={(group) => {
            setCreateOpen(false);
            setEditGroupId(group.id);
          }}
        />
      </div>

      <GroupFormDrawer
        mode={formMode}
        groupId={editGroupId}
        isOpen={formOpen}
        onClose={closeForm}
        onSaved={() => void refetch()}
      />
    </View>
  );
};
